export default __webpack_public_path__ + "static/media/phil1.9ac9267a.jpg";